import { render, staticRenderFns } from "./RemoveButton.vue?vue&type=template&id=ed174910&"
import script from "./RemoveButton.js?vue&type=script&lang=js&"
export * from "./RemoveButton.js?vue&type=script&lang=js&"
import style0 from "./RemoveButton.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports